import React from "react";
import { ArrowRight } from "lucide-react";
import { variants } from "animations/variants";

const CTAButton = ({
  text,
  icon: Icon,
  onClick,
  className = "",
  size = 16,
  variant = "primary",
}) => {
  return (
    <button
      onClick={onClick}
      className={`
  group
  inline-flex items-center gap-2 justify-center
  rounded-full
  px-6 py-3
  font-semibold
  tracking-wide
  transition-all duration-300
  hover:-translate-y-0.5
  ${variants[variant]}
  ${className}
`}
    >
      {Icon && (
        <Icon
          size={size}
          className="
            transition-transform
            duration-300
            group-hover:rotate-12
          "
        />
      )}

      <span className="uppercase">{text}</span>

      <ArrowRight
        size={14}
        className="
          opacity-0
          -ml-2
          transition-all
          duration-300
          group-hover:opacity-100
          group-hover:ml-0
        "
      />
    </button>
  );
};

export default CTAButton;
